import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import quiz from './quiz';
import rest from './rest';
import pageOverride from './page';

const reducers = combineReducers({
  routing: routerReducer,
  quiz,
  rest,
  pageOverride
});

export default reducers;
